import { render, staticRenderFns } from "./LoginFormModal.vue?vue&type=template&id=c1bac0d4&"
import script from "./LoginFormModal.vue?vue&type=script&lang=js&"
export * from "./LoginFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports